export const seo = ({
	title,
	description,
	keywords,
	image,
	url,
	largeImage,
}: {
	title: string;
	description?: string;
	image?: string;
	keywords?: string;
	/** canonical/share URL → emits og:url (optional; omit to keep prior behaviour) */
	url?: string;
	/** use the large summary card instead of the default `summary` (optional) */
	largeImage?: boolean;
}) => {
	const tags = [
		{ title },
		{ name: 'description', content: description },
		{ name: 'keywords', content: keywords },
		{ name: 'twitter:title', content: title },
		{ name: 'twitter:description', content: description },
		{ name: 'og:type', content: 'website' },
		{ name: 'og:title', content: title },
		{ name: 'og:description', content: description },
		...(url ? [{ name: 'og:url', content: url }] : []),
		...(image
			? [
					{ name: 'twitter:image', content: image },
					{
						name: 'twitter:card',
						content: largeImage ? 'summary_large_image' : 'summary',
					},
					{ name: 'og:image', content: image },
				]
			: []),
	];

	return tags;
};
